import { flow, types } from "mobx-state-tree";
import api from "services/api";

const Coach = types
  .model("Coach", {
    isLoading: types.optional(types.boolean, false),
    coachReferralId: types.maybeNull(types.string),
  })
  .actions(self => ({
    syncCoachConnect: flow(function* () {
      try {
        self.isLoading = true;
        
        const response = yield api.put(
          `/coach/api/v1/mobile/coach-connect-sync`,{},undefined,'MSURL'
          
        );

        if (response?.data?.coachReferralId) {
          self.coachReferralId = response.data.coachReferralId;
          console.log("CoachReferralId actualizado:", self.coachReferralId);
        }
        
        return response;
      } catch (error) {
        console.error("Error en syncCoachConnect:", error);
        throw error;
      } finally {
        self.isLoading = false;
      }
    }),
  }));
  
const CoachStore = Coach.create();

export default CoachStore;